import classnames from 'classnames'
import PropTypes from 'prop-types'

import useStyles from './styles'

const VideoThumbnail = ({ videoPicture, fileName, onLoad, mediaThumbnailImageRatio, videoPictureClassName }) => {
  const classes = useStyles()

  return mediaThumbnailImageRatio ? (
    <img
      onLoad={onLoad}
      src={videoPicture}
      alt={fileName}
      className={classnames(classes.videoPicture, videoPictureClassName)}
    />
  ) : (
    <div className={classes.imagePlaceholder} />
  )
}

VideoThumbnail.propTypes = {
  videoPicture: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  onLoad: PropTypes.func.isRequired,
  mediaThumbnailImageRatio: PropTypes.number,
  videoPictureClassName: PropTypes.string
}

export default VideoThumbnail
